import { default as domainTeacherIndicator } from './indicator/store'
import { default as teacherPositionCategory } from './position-category/store' 

export default { 
	domainTeacherIndicator,
	teacherPositionCategory
}